import Framework7 from 'framework7';
import EventBus from '../js/event-bus';
import { APP_VERSION } from '../js/constants';

export default {
  request(url, payload, verb, processData = true, contentType = 'application/x-www-form-urlencoded', headerAuth, enabledCache,
    headerCompany = null, callback, timeout = 180000) {
    Framework7.request({
      url,
      method: verb,
      cache: enabledCache,
      data: payload.data,
      processData,
      contentType,
      timeout,
      headers: {
        Authorization: headerAuth,
        company: headerCompany,
        'App-version': this.getAppVersion(),
      },
      complete: callback,
    });
  },
  // custom request for NDJSON stream
  requestStream(url, payload, verb, contentType = 'application/json', headerAuth, enabledCache,
    headerCompany = null, callback, timeout = 360000) {
    const headers = {};
    if (headerAuth) {
        headers['Authorization'] = headerAuth;
    }
    headers['App-version'] = this.getAppVersion();
    if (headerCompany) {
        headers['company'] = headerCompany;
    }
    headers['Accept'] = contentType;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    fetch(url, {
      method: verb,
      headers: headers,
      cache: enabledCache ? 'default' : 'no-store',
      signal: controller.signal,
    })
    .then(async (response) => {
      clearTimeout(timeoutId);
      const status = response.status;
      if (status >= 300) {
        if (status === 401) {
          EventBus.$emit('invalidTokenDetected');
        }
        callback(response, status);
        return;
      }


      // Read NDJSON line by line
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let { value, done } = await reader.read();
      let buffer = '';

      response.data = [];

      while (!done) {
          buffer += decoder.decode(value, { stream: true });
          let lines = buffer.split('\n');
          buffer = lines.pop();

          for (let line of lines) {
              if (line.trim()) {
                  try {
                      const obj = JSON.parse(line);
                      response.data.push(obj);
                  } catch (err) {
                      console.error('JSON parse error', err, line);
                  }
              }
          }

          ({ value, done } = await reader.read());
      }

      // possibly a partial line at the end
      if (buffer.trim()) {
          try {
              const obj = JSON.parse(buffer);
              response.data.push(obj);
          } catch (err) {
              console.error('JSON parse error', err, buffer);
          }
      }

      callback(response, status);
    })
    .catch((error) => {
      clearTimeout(timeoutId);
      const status = error.name === 'AbortError' ? 'timeout' : 'error';
      callback({ response: error.message }, status);
    });
  },
  getAppVersion() {
    const appVersionSplitted = APP_VERSION.split('-');
    if (appVersionSplitted.length > 1) {
      return appVersionSplitted[0];
    }
    return APP_VERSION;
  },
  async(url, payload, verb, processData, contentType, headerAuth = null, headerCompany = null, enabledCache = false, timeout = 180000) {
    const self = this;
    return new Promise(((resolve, reject) => {
      self.request(url, payload, verb, processData, contentType, headerAuth, enabledCache, headerCompany,
        (xhr, status) => {
          if (status >= 300 || status === 'timeout') {
            if (status === 401) {
              EventBus.$emit('invalidTokenDetected');
            }
            const err = new Error(`${xhr.response}`);
            err.statusCode = status;
            reject(err);
          }
          try {
            resolve(xhr);
          } catch (e) {
            reject(e);
          }
        }, timeout);
    }));
  },

  asyncStream(url, payload, verb, contentType, headerAuth = null, headerCompany = null, enabledCache = false) {
    const self = this;
    return new Promise(((resolve, reject) => {
      self.requestStream(url, payload, verb, contentType, headerAuth, enabledCache, headerCompany,
        (xhr, status) => {
          if (status >= 300 || status === 'timeout') {
            if (status === 401) {
              EventBus.$emit('invalidTokenDetected');
            }
            reject(new Error(`${xhr.response}`, { cause: status }));
          }
          try {
            resolve(xhr);
          } catch (e) {
            reject(e);
          }
        });
    }));
  },

  async blobRequest(url, callback) {
    const logoRes = await fetch(url);
    const blob = await logoRes.blob();
    const reader = new FileReader();
    reader.onloadend = () => callback(reader.result);
    reader.readAsDataURL(blob);
  },
};
